import React, { useState , useRef} from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import gifImage from '../assets/images/Logo_animation.gif'

const GifLoder = () => {
    const [value, setValue] = useState('');
    return (
        <>
            <img src={gifImage} alt="gif" className="loderDivimg" />
        </>
        );
    };
export default GifLoder;